import ApplicationGroup from "./applicationGroup";
export default ApplicationGroup;